<div class="container-fluid justify-content-center mb-1 pt-2 pb-0 shadow-lg col-12">
    <div class="jumbotron-fluid mx-0 px-0 mt-1 pt-3 mb-0 pb-0">
        <div class="container my-2 mx-0 shadow-lg">
            <div class="row">
                <div class="col-12">
                    <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
                        Enroll Client
                    </h3>
                </div>
            </div>
        </div>
        <!-- <div class="container my-0 py-0 mx-auto px-auto">
        <div class="d-flex my-0 py-0 mx-auto px-auto">
            <div class="col-12 mx-auto px-auto">
              <h5 class="text-center text-black"> Provide Personal Information as a MUST.</h5>
              <h5 class="text-center text-black"> To attach product(s), simply tap Next button to choose any or all of the products.</h5>
              </div>
          </div>
      </div> -->
    </div>
</div>
<app-personal-info></app-personal-info>